<avano-error-page [errorNumber]="errorToShow" (backToLogin)="backToLogin()"></avano-error-page>
